/**
 * Reducer for state.ui.workflowVisualization
 */
import {BenchlingAction} from 'redux-stores/Action';

import {WorkflowVisualizationActionType} from './WorkflowVisualizationReduxActions';

/**
 * clickedUpstreamNodeId and clickedDownstreamNodeId either both represent the same node,
 * or represent the parent and child of a link.
 */
export interface WorkflowVisualizationState {
  clickedUpstreamNodeId: string | null;
  clickedDownstreamNodeId: string | null;
  rightClickedNodeId: string | null;
  hoveredNodeId: string | null;
}

const INITIAL_STATE: WorkflowVisualizationState = {
  clickedUpstreamNodeId: null,
  clickedDownstreamNodeId: null,
  rightClickedNodeId: null,
  hoveredNodeId: null,
};

export default function reduceWorkflowVisualization(
  state: WorkflowVisualizationState = INITIAL_STATE,
  action: BenchlingAction
): WorkflowVisualizationState {
  switch (action.type) {
    case WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_RESET:
      return INITIAL_STATE;
    case WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_CLICK_NODE:
      return {
        ...state,
        clickedUpstreamNodeId: action.nodeId,
        clickedDownstreamNodeId: action.nodeId,
      };
    case WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_CLICK_LINK:
      return {
        ...state,
        clickedUpstreamNodeId: action.parentNodeId,
        clickedDownstreamNodeId: action.childNodeId,
      };
    case WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_RIGHT_CLICK_NODE:
      return {...state, rightClickedNodeId: action.nodeId};
    case WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_HOVER_NODE:
      return {
        ...state,
        hoveredNodeId: action.nodeId,
      };
    case WorkflowVisualizationActionType.WORKFLOW_VISUALIZATION_UNHOVER_NODE:
      return {
        ...state,
        hoveredNodeId: null,
      };
    default:
      return state;
  }
}
